export const SELECTION_ISLAND_CHROME =
  "border border-emerald-300 bg-white/95 shadow-lg shadow-emerald-900/10 ring-1 ring-emerald-500/10 backdrop-blur-md transition-shadow duration-200 hover:shadow-xl hover:shadow-emerald-900/15";

export function selectionIslandMotion(isVisible: boolean): string {
  return isVisible
    ? "animate-in fade-in slide-in-from-bottom-2"
    : "pointer-events-none animate-out fade-out slide-out-to-bottom-2 fill-mode-forwards";
}
